import { EnumTipoPropagandaLocal } from "model/enums/enum-tipo-propaganda-local";
import { EnumTipoPropagandaDestaque } from "model/enums/enum-tipo-propaganda-destaque";
import { guidEmpty } from "utils/guid-empty";

export class PropagandaFormFields {
    constructor(
        public id: string = guidEmpty(),
        public revendaId:string | null = null,
        public descricao: string = '',
        public html: string = '',
        public dtInicial: string = '',
        public dtFinal: string = '',
        public local: EnumTipoPropagandaLocal = EnumTipoPropagandaLocal.Ambos,
        public ativo: boolean = true,
        public tempoExibicao = 0,
        public tempoMinimo = 0,
        public ignoraVisualizacao = false,
        public destaque: EnumTipoPropagandaDestaque = EnumTipoPropagandaDestaque.NaoInformado,
        public respostasDisponiveis: string = '',
    ) { }
}   